import { formatDate } from '@/utils/formatDate';

export const EventCard = ({ event }) => (
  <a href={`/professionals/events/${event.event_slug}`}>
    <div className="w-[361px] justify-start items-center gap-4 inline-flex mb-5">
      <img
        className="w-[132px] self-stretch rounded-lg"
        src={event.event_image_url}
        alt={event.event_image_alt_text}
        loading="eager"
      />
      <div className="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
        <div className="self-stretch menu-news-article-title">{event.event_title_breadcrumb}</div>
        <div className="self-stretch h-6 flex-col justify-start items-start flex">
          <div className="self-stretch menu-news-article-text">{event.event_type}</div>
        </div>
        <div className="self-stretch menu-event-date">
          {formatDate(event.event_date)}
        </div>
      </div>
    </div>
  </a>
);
